import styled, { CSSProperties } from "styled-components";
import themeProps from "theme/themes";

interface TextButtonProps {
  label: string;
  onClick: () => void;
  styles?: CSSProperties;
}

const Button = styled.button`
  color: ${(props: themeProps) => props.theme.button.primary.normal};
  background-color: transparent;
  border: none;
  outline: none;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
`;

const TextButton = ({ label, onClick, styles }: TextButtonProps) => {
  return (
    <Button onClick={onClick} style={styles}>
      {label}
    </Button>
  );
};

export default TextButton;
